// Temporarily locked in the widget and every designer route.
// Coach access remains enforced by the route gate and backend authorization.
export const SESSIONS_DESIGNER_ENABLED = false;
